export const predictionData = [
  {
    id: 1,
    question: "Will Bitcoin reach $100,000 by the end of 2023?",
    description: "This market will resolve to YES if the price of Bitcoin reaches or exceeds $100,000 USD on any major exchange before January 1, 2024.",
    category: "crypto",
    endDate: "December 31, 2023",
    totalVolume: "$24,560",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 32,
        price: 0.32
      },
      {
        id: 2,
        text: "No",
        probability: 68,
        price: 0.68
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 2,
    question: "Will Donald Trump be the Republican nominee for the 2024 presidential election?",
    description: "This market will resolve to YES if Donald Trump becomes the official Republican Party nominee for the 2024 US Presidential Election.",
    category: "politics",
    endDate: "July 15, 2024",
    totalVolume: "$156,230",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 78,
        price: 0.78
      },
      {
        id: 2,
        text: "No",
        probability: 22,
        price: 0.22
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1540910419892-4a36d2c3266c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 3,
    question: "Will 'Dune: Part Two' gross over $500 million worldwide?",
    description: "This market resolves to YES if 'Dune: Part Two' grosses more than $500 million USD in worldwide box office according to Box Office Mojo.",
    category: "entertainment",
    endDate: "April 30, 2024",
    totalVolume: "$18,750",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 85,
        price: 0.85
      },
      {
        id: 2,
        text: "No",
        probability: 15,
        price: 0.15
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1536440136628-849c177e76a1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 4,
    question: "Will SpaceX successfully land humans on Mars before 2030?",
    description: "This market resolves to YES if SpaceX successfully lands at least one human on the surface of Mars before January 1, 2030.",
    category: "science",
    endDate: "December 31, 2029",
    totalVolume: "$42,890",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 23,
        price: 0.23
      },
      {
        id: 2,
        text: "No",
        probability: 77,
        price: 0.77
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1614728894747-a83421e2b9c9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 5,
    question: "Will the Federal Reserve cut interest rates before the end of 2023?",
    description: "This market resolves to YES if the Federal Reserve announces a cut to the federal funds rate before December 31, 2023.",
    category: "economics",
    endDate: "December 31, 2023",
    totalVolume: "$87,340",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 42,
        price: 0.42
      },
      {
        id: 2,
        text: "No",
        probability: 58,
        price: 0.58
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 6,
    question: "Will the Kansas City Chiefs win the Super Bowl in 2024?",
    description: "This market resolves to YES if the Kansas City Chiefs win Super Bowl LVIII, which will be played in February 2024.",
    category: "sports",
    endDate: "February 11, 2024",
    totalVolume: "$65,120",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 18,
        price: 0.18
      },
      {
        id: 2,
        text: "No",
        probability: 82,
        price: 0.82
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1508098682722-e99c643e7f3b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 7,
    question: "Will Apple release a foldable device before the end of 2024?",
    description: "This market resolves to YES if Apple officially announces and releases a foldable smartphone, tablet, or laptop before December 31, 2024.",
    category: "technology",
    endDate: "December 31, 2024",
    totalVolume: "$31,450",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 35,
        price: 0.35
      },
      {
        id: 2,
        text: "No",
        probability: 65,
        price: 0.65
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1491933382434-500287f9b54b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 8,
    question: "Will Taylor Swift release a new album in 2024?",
    description: "This market resolves to YES if Taylor Swift releases a new studio album (not a re-recording) in 2024.",
    category: "entertainment",
    endDate: "December 31, 2024",
    totalVolume: "$28,760",
    options: [
      {
        id: 1,
        text: "Yes",
        probability: 72,
        price: 0.72
      },
      {
        id: 2,
        text: "No",
        probability: 28,
        price: 0.28
      }
    ],
    imageUrl: "https://images.unsplash.com/photo-1619983081563-430f63602796?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1200&q=80"
  }
]
export const predictionCategories = [
  { id: "all", name: "All Markets" },
  { id: "politics", name: "Politics" },
  { id: "crypto", name: "Crypto" },
  { id: "entertainment", name: "Entertainment" },
  { id: "sports", name: "Sports" },
  { id: "technology", name: "Technology" },
  { id: "science", name: "Science" },
  { id: "economics", name: "Economics" }
]
export const trendingPredictions = [
  {
    id: 2,
    question: "Will Donald Trump be the Republican nominee for the 2024 presidential election?",
    volume: "$156,230"
  },
  {
    id: 5,
    question: "Will the Federal Reserve cut interest rates before the end of 2023?",
    volume: "$87,340"
  },
  {
    id: 6,
    question: "Will the Kansas City Chiefs win the Super Bowl in 2024?",
    volume: "$65,120"
  },
  {
    id: 1,
    question: "Will Bitcoin reach $100,000 by the end of 2023?",
    volume: "$24,560"
  }
]